
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.926 15.931a3.126 3.126 0 113.126-3.125 3.129 3.129 0 01-3.126 3.125zm0-5.1a1.976 1.976 0 101.976 1.976 1.978 1.978 0 00-1.976-1.977z","fill":"currentColor","stroke":"currentColor","stroke-width":".25"}}),_c('path',{attrs:{"d":"M12 18.396c-4.739 0-8.476-4.744-8.887-5.285a.584.584 0 010-.688c.413-.544 4.15-5.288 8.889-5.288s8.477 4.744 8.887 5.285a.584.584 0 010 .687c-.412.545-4.15 5.289-8.889 5.289zm-7.7-5.63c.987 1.172 4.1 4.487 7.7 4.487s6.714-3.315 7.7-4.487c-.987-1.173-4.1-4.489-7.7-4.489s-6.715 3.316-7.698 4.488z","fill":"currentColor","stroke":"currentColor","stroke-width":".25"}}),_c('path',{attrs:{"stroke":"red","stroke-linecap":"round","stroke-width":"1.5","d":"M3.6 17.8l16.8-10"}})])
          )
        }
      }
    